var React = require('react');

function CircleOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 3C6.85786 3 3.5 6.35786 3.5 10.5C3.5 14.6421 6.85786 18 11 18C15.1421 18 18.5 14.6421 18.5 10.5C18.5 6.35786 15.1421 3 11 3ZM0.5 10.5C0.5 4.70101 5.20101 0 11 0C16.799 0 21.5 4.70101 21.5 10.5C21.5 16.299 16.799 21 11 21C5.20101 21 0.5 16.299 0.5 10.5Z"}));
}

CircleOutline.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21","fill":"currentColor"};

module.exports = CircleOutline;

CircleOutline.default = CircleOutline;
